import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { createSelector } from '@reduxjs/toolkit';
import { PureComponent } from 'react';
import { QueryPreviewTabs } from '../types.js';
import { renderTabPanelButtonId, renderTabPanelId } from '../utils/a11y.js';
import { emptyRecord, identity } from '../utils/object.js';
import { TreeView } from './TreeView.js';
const keySep = ' - ';
const rootProps = {
    'aria-labelledby': renderTabPanelButtonId(QueryPreviewTabs.actions),
    id: renderTabPanelId(QueryPreviewTabs.actions),
    role: 'tabpanel',
};
export class QueryPreviewActions extends PureComponent {
    constructor() {
        super(...arguments);
        this.selectFormattedActions = createSelector(identity, (actions) => {
            const output = {};
            if (actions.length === 0) {
                return emptyRecord;
            }
            for (let i = 0, len = actions.length; i < len; i++) {
                const action = actions[i];
                const key = `${i}${keySep}${action?.type ?? ''}`;
                output[key] = action;
            }
            return output;
        });
        this.isLastActionNode = (keyPath, layer) => {
            if (layer >= 1) {
                const len = this.props.actionsOfQuery.length;
                const actionKey = keyPath[keyPath.length - 1];
                if (typeof actionKey === 'string') {
                    const index = Number(actionKey.split(keySep)[0]);
                    return len > 0 && len - index < 2;
                }
            }
            return false;
        };
        this.shouldExpandNodeInitially = (keyPath, value, layer) => {
            if (layer === 1) {
                return this.isLastActionNode(keyPath, layer);
            }
            if (layer === 2) {
                return (this.isLastActionNode(keyPath, layer) &&
                    (keyPath[0] === 'meta' || keyPath[0] === 'error'));
            }
            return layer <= 1;
        };
    }
    render() {
        const { isWideLayout, actionsOfQuery } = this.props;
        return (_jsx(TreeView, { rootProps: rootProps, data: this.selectFormattedActions(actionsOfQuery), isWideLayout: isWideLayout, shouldExpandNodeInitially: this.shouldExpandNodeInitially }));
    }
}
